__turbopack_context__.v({
  "body": "txwB6G_body",
  "viewport": "txwB6G_viewport",
  "window": "txwB6G_window",
});
